import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalHeaderComponent } from '../../modal-header/modal-header.component';
import { Notificacao } from '../notificacoes.type';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-modal-notificacao',
  imports: [ModalHeaderComponent, MatButtonModule],
  templateUrl: './modal-notificacao.component.html',
  styleUrl: './modal-notificacao.component.scss'
})
export class ModalNotificacaoComponent {

  protected dialogRef = inject(MatDialogRef<ModalNotificacaoComponent>);
  protected readonly _notificacao: Notificacao = inject(MAT_DIALOG_DATA);

  protected handleOpenLink = (): void => {
    window.open(this._notificacao.descricao.link, '_blank');
  }

}
